import React from 'react';
import uuid from 'uuid';
import {
	Container,
	Title,
	FunnelDiv,
	WTitle,
	WText,
} from '../style';
import FacebookIcon from '../../../../img/facebookCircle.png';
import DynamicReportTemplate from '../../Charts/DynamicReportTemplate';
import FunnelChart from '../../Charts/Widgets/FunnelChart';
import colors from '../../../../config/colors.json';
import GoogleAds from '../../../../img/googlePNG.png';
import InstagramSvg from '../../../../img/instagram.svg';
import { LoaderPdf } from '../../../Loader';
import { ButtonCampaign } from '../../../utilities/styledComponents/ButtonCampaign';

export default ({
	reportTemplates,
	channel,
	exportReport,
	exportLoading,
	reportId,
	setReportTemplates,
	startDate,
	endDate,
}) => {
    const channelsData = {
        google: {
            name: 'Google Ads',
            logo: GoogleAds,
            color: colors.dark,
        },
        facebook: {
            name: 'Facebook',
            logo: FacebookIcon,
            color: colors.fblue,
        },
        instagram: {
            name: 'Instagram',
            logo: InstagramSvg,
            color: colors.igpurple,
        },
    };

    const currentChannel = channelsData[channel];
    const { name, logo, color } = currentChannel;

    return (
	<Container>
		<div className="d-flex justify-content-between">
			<Title color={color}>
				<img src={logo} alt={`Logo do ${name}`} width={34} /> {name}
			</Title>
			<ButtonCampaign
				type="link"
				onClick={exportReport}
				padding="11px 12px"
				disabled={exportLoading}
				border="1px solid #F3123C"
				width="134px"
				color="#F3123C"
				fontSize="12px"
				borderRadius="8px"
				marginRight="0"
				lineHeight="18px"
			>
				{ exportLoading ? (<LoaderPdf />) : 'Exportar relatório' }
			</ButtonCampaign>
		</div>
		{
            reportTemplates.map((report, index) => (report.variables ? (
	<div className="no-break">
		<DynamicReportTemplate
			tag={report.variables.component}
			channel={channel}
			data={report}
			isLast={(reportTemplates.length - 1 === index)}
			key={uuid.v4()}
			reportId={reportId}
			setReportTemplates={setReportTemplates}
			startDate={startDate}
			endDate={endDate}
		/>
	</div>
            ) : null))
        }
		<hr />
		<FunnelDiv>
			<WTitle>
				Minhas conversões
			</WTitle>
			<WText>
				{`Abaixo um funil das conversões realizadas com base nos leads
                recebidos através desta campanha de ${name}.`}
			</WText>
			<div className="d-flex flex-column align-items-start funnel-chart">
				<FunnelChart
					number="1000"
					text="Leads gerados"
					numberTwo="800"
					textTwo="Leads em negociação"
					numberThree="400"
					textThree="Visitas agendadas"
					numberFour="380"
					textFour="Visitas realizadas"
					numberFive="100"
					textFive="Vendas realizadas"
					percentage="8,8%"
				/>
			</div>
		</FunnelDiv>
	</Container>
    );
};
